import { Button } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  viewRecord: {
    id: 'taskAssociations.viewRecord',
    default: 'View record',
  },
});

interface TaskAssociationsProps {
  route?: string | null;
}

export const TaskAssociations = ({ route }: TaskAssociationsProps) => {
  const { formatMessage } = useIntl();
  if (!route) {
    return null;
  }

  const handleNavigate = () => {
    navigate(route);
  };

  return (
    <Button
      endIcon={<Icon name="circle-chevron-right" />}
      onClick={handleNavigate}
      sx={{ fontSize: '12px' }}
      variant="outlined"
    >
      {formatMessage(messages.viewRecord)}
    </Button>
  );
};
